var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._b({staticClass:"button -secondary mt-2 mb-2",attrs:{"id":"mikmak-button","data-mm-ids":_vm.productId,"data-mm-wtbid":_vm.mikmakWidgetId,"data-mm-sticky":_vm.mikmakStickyButton,"aria-label":_vm.labelText}},'button',_vm.additionalProp,false),[_vm._v(" "+_vm._s(_vm.labelText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }